import React from 'react';
import Button from '../../../../components/shared/button';
import DefaultLogo from '../../../../assets/dummy/cards/puzzle.png';
import { Link } from 'react-router-dom';

// ./../../../assets/dummy/cards/puzzle.png
export default function HomeFeedCard({ iconReference,
  title, vender, category, description, transactionText, buttonText, onClick }) {
  return <section className="home-feed-card">
    <div className='header'>
      <figure onClick={onClick}>
        <img src={iconReference ? iconReference : DefaultLogo} alt='int-logo'  />
      </figure>
    </div>
    <div className="body">
      <h2 title={title} onClick={onClick}>{title}</h2>
      <Link to={`/?page=&category=${category ? category.toLowerCase() : ''}&search=`}>
        <span>{category}</span>
      </Link>
      <p>{vender}</p>
      <p> {description}</p>
    </div>
    <div className='footer'>
      <label>{transactionText}</label>
      <Button
        text={buttonText}
        variant="btn-primary"
        handleClick={onClick}
      />
    </div>
  </section>
}